import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const deleteKbTag = createAsyncThunk(
  'kbTag/deleteKbTag',
  async (tagId, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.delete(
        `${BASE_URL}/trustchat-backend-service/v1/kb/tag/${tagId}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const deleteKbTagSlice = createSlice({
  name: 'deleteKbTag',
  initialState,
  reducers: {
    resetDeleteKbTagState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteKbTag.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteKbTag.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        toast.success(action.payload.message || 'Knowledge Base tag deleted successfully!');
      })
      .addCase(deleteKbTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message || 'Failed to delete tag.');
      });
  }
});

export const { resetDeleteKbTagState } = deleteKbTagSlice.actions;
export default deleteKbTagSlice.reducer;